import { useState, useEffect, useRef } from "react";
import { Grid, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import GeneralNoPaginationTable from '../components/Table/GeneralNoPaginationTable';
import MainCard from '../components/MainCard';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import MixedChart from '../components/Chart/MixedChart';



const summaries_columns = [
  { id: 'data_month', label: 'Month', align: 'center'},
  { id: 'total', label: 'Total', align: 'center'},
  { id: 'automated', label: 'Automated', align: 'center'},
  { id: 'percentage', label: '%', align: 'center'},
];


const TestRailOtherAutomatedInfoPage = () => {
    const navigate = useNavigate();
    const [summariesData, setSummariesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [percentage, setPercentage] = useState([]);
    const [totalList, setTotalList] = useState([]);
    const [automatedList, setAutomatedList] = useState([]);
    const [selected, setSelected] = useState('75');
    const initialFetchRef = useRef(true);
    const [selectedTitle, setSelectedTitle] = useState('Product High Level Test');
    const handleSelection = (event, newSelection) => {
      setSelected(newSelection);
      getTestrailAutomatedCases(newSelection);
      if (newSelection === '75') {
        setSelectedTitle('Product High Level Test');
      }else if (newSelection === '11054') {
        setSelectedTitle('Commercial');
      }else if (newSelection === '14892') {
        setSelectedTitle('G700 Smoke Test');
      }else if (newSelection === '344') {
        setSelectedTitle('Firmware: Prism');
      }else if (newSelection === '357') {
        setSelectedTitle('Titan System Integration');
      }else if (newSelection === '1') {
        setSelectedTitle('Prism System Integration');
      }else if (newSelection === '2') {
        setSelectedTitle('Caesar System Integration');
      }
    };

    const SuiteToggleButton = styled(ToggleButton)({
      flex: 1,
      boxShadow: 'none',
      textTransform: 'none',
      color: '#406599',
      '&:hover': {
        backgroundColor: '#c6e5fb',
      },
      "&.Mui-selected, &.Mui-selected:hover": {
        color: "#406599",
        backgroundColor: '#9cd1f8'
      }
    });


    const getTestrailAutomatedCases = async (selected) => {
      try {
        var input_data = JSON.stringify({ suite_id: parseInt(selected) });
        const response = await axios.post("/peloton/v1/automation/testrail-automated-report", input_data, { withCredentials: true});
        if (response.data.message === "success"){
                    setCategories(response.data.categories);
                    setPercentage(response.data.percentage_list);
                    setTotalList(response.data.total_list);
                    setAutomatedList(response.data.automated_list);
                    setSummariesData(response.data.data);
        }
      } catch (error) {
                if (error.response.status !== null){
                    if (error.response.status === 401){
                        alert(error.response.data.message);
                        navigate("/");
                    }else{
                        console.log('error.response.status: ', error.response.status)
                        console.log('error.response.message: ', error.response.data.message)
                    }
                }else{
                    console.log(error);
                }
      }finally {
                setLoading(false);
      }
    };

    

    useEffect(() => {
      if (initialFetchRef.current) {
        initialFetchRef.current = false;
        getTestrailAutomatedCases(selected);
      } 
    }, [selected]);

    if (loading) {
        return <div>Loading...</div>;
    }


    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "45px", marginLeft: "40px"}}>
            <MainCard title={'Other Automated Cases'}>
            <Grid item xs={12} sx={{ minWidth: "1080px"}}>
            <ToggleButtonGroup
              value={selected}
              exclusive
              onChange={handleSelection}
              aria-label="select option"
              sx={{ display: "flex", width: "100%"}}
            >
              <SuiteToggleButton value="75" aria-label="Product High Level Test">
                Product High Level Test
              </SuiteToggleButton>
              <SuiteToggleButton value="11054" aria-label="Commercial">
                Commercial
              </SuiteToggleButton>
              <SuiteToggleButton value="14892" aria-label="G700 Smoke Test">
                G700 Smoke Test
              </SuiteToggleButton>
              <SuiteToggleButton value="344" aria-label="Firmware: Prism">
                Firmware: Prism
              </SuiteToggleButton>
              <SuiteToggleButton value="357" aria-label="Titan System Integration">
                Titan System Integration
              </SuiteToggleButton>
              <SuiteToggleButton value="1" aria-label="Prism System Integration">
                Prism System Integration
              </SuiteToggleButton>
              <SuiteToggleButton value="2" aria-label="Caesar System Integration">
                Caesar System Integration
              </SuiteToggleButton>
            </ToggleButtonGroup>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "20px"}}>
                <GeneralNoPaginationTable rows={summariesData} columns={summaries_columns} title="Created and Updated Test Cases"/>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "20px"}}>
              <MixedChart isLoading={loading} categories={categories} percentage={percentage} totalList={totalList} automatedList={automatedList} selected={selected} selectedTitle={selectedTitle}/>
            </Grid>
            </MainCard>
        </Grid>
    );
};

export default TestRailOtherAutomatedInfoPage;
